import React from 'react';
import PropTypes from 'prop-types';
import UpgradeIcon from 'components/shared/DesignSystem/UpgradeIcon';
import useMenuActionBeforeAfter from '../actions/useMenuActionBeforeAfter';
import { Button, Text } from '@companycam/slab-web';
import styled from 'styled-components';
import CCTooltip from 'components/shared/DesignSystem/CCFloating/CCTooltip';
import { translate } from 'translations/i18n';

const TooltipContainer = styled.div`
  display: flex;
  text-align: center;
`;
const StyledUpgradeIcon = styled(UpgradeIcon)`
  position: relative;
  margin-left: 8px;
`;

const MenuItemBeforeAfter = (props) => {
  const {
    action: actionBeforeAfter,
    validSelection,
    canAccessBeforeAfterPhotos,
    renderedModal,
  } = useMenuActionBeforeAfter(props.menuItemOptions);

  const isButtonDisabled = !validSelection;

  const renderBeforeAfterUpgradeIcon = !canAccessBeforeAfterPhotos ? (
    <StyledUpgradeIcon />
  ) : null;

  const Action = (
    <Button
      color="secondary"
      design="minimal"
      icon={{ name: 'compare', position: 'before' }}
      onClick={actionBeforeAfter}
      disabled={isButtonDisabled}
    >
      {translate('assets.selectedAssetBar.createBeforeAfter')}
      {renderBeforeAfterUpgradeIcon}
    </Button>
  );

  return (
    <>
      {isButtonDisabled ? (
        <CCTooltip
          position="bottom"
          offset={24}
          triggerStyle="hover"
          trigger={Action}
        >
          <TooltipContainer>
            <Text as="p" size="s" weight="700" family="heading">
              {translate('assets.selectedAssetBar.beforeAfterTooltip')}
            </Text>
          </TooltipContainer>
        </CCTooltip>
      ) : (
        Action
      )}
      {renderedModal}
    </>
  );
};

MenuItemBeforeAfter.propTypes = {
  menuItemOptions: PropTypes.shape({
    assets: PropTypes.array,
    assetsByType: PropTypes.object,
  }),
};

export default MenuItemBeforeAfter;
